import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type ModuleStatus,
  patchModulesModuleIDStatus,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { getModuleDetailQueryKey } from "../Queries/useModuleDetailQuery";

interface UpdateModuleStatusParams {
  moduleID: string;
  status: ModuleStatus;
}

export function useUpdateModuleStatusMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ moduleID, status }: UpdateModuleStatusParams) =>
      patchModulesModuleIDStatus(status, moduleID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { moduleID }) => {
      queryClient.invalidateQueries({
        queryKey: ["MODULES_QUERY"],
      });
      queryClient.invalidateQueries({
        queryKey: getModuleDetailQueryKey(moduleID),
      });
    },
  });
}
